import {
  CompositeResourceCache,
  IResourceCache,
  ResourceCache,
  SceneBuilder,
  SceneObject,
  SceneResource,
} from '@cgs/wge';

export const SCENE_FACTORY_TOKEN = Symbol('SceneFactory');

export const ASPECTS = ['Web', '16x9', /*"4x3",*/ '3x2', ''];

export class SceneFactory {
  protected readonly _sceneBuilder: SceneBuilder;
  protected _resourceCache: IResourceCache;
  protected _common: IResourceCache;

  constructor(sceneBuilder: SceneBuilder, resourceCache: ResourceCache) {
    this._sceneBuilder = sceneBuilder;
    this._resourceCache = resourceCache;
    this._common = new CompositeResourceCache(resourceCache, ['common']);
  }

  public build(resourceId: string, packages?: string[]): SceneObject | null {
    let sceneResource: SceneResource | null = null;
    for (let i = 0; i < ASPECTS.length; ++i) {
      sceneResource = this._resourceCache.getResource(
        SceneResource.TypeId,
        resourceId + ASPECTS[i] + '.object'
      );
      if (sceneResource) {
        break;
      }
    }

    if (!sceneResource) {
      return null;
    }

    const resourceCache = packages
      ? new CompositeResourceCache(this._common, packages)
      : this._common;

    return this._sceneBuilder.build(resourceCache, sceneResource.data!, resourceId);
  }
}
